import { useMutation } from '@tanstack/react-query';
import { deleteUserPreference } from '../requests';
import type { DeleteUserPreferenceRequest } from '../types';

/**
 * Raw DELETE mutation for the user preference layer. Cache management is
 * delegated to the owning hook (`useUserPreference`) — same rationale as
 * {@link usePatchUserPreference}: avoids overwriting a newer optimistic
 * update with a stale response.
 */
export const useDeleteUserPreference = <T extends Record<string, unknown>>() =>
  useMutation({
    mutationFn: (params: DeleteUserPreferenceRequest) =>
      deleteUserPreference<T>(params),
  });
